import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {WorkflowService} from '../../../../services/workflow.service';
import {Observable, of, Subscription} from 'rxjs';
import {WorkflowReviewDto, WorkflowStepInstance, WorkflowStepInstanceSection, WorkflowStepInstanceToSave} from '../../../../models/workflow/workflow-step-instance.interface';
import { AppFormComponent } from 'app/modules/app-form/form-test/app-form.component';
import { UntypedFormControl } from '@angular/forms';
import { StakeholdersDto } from 'app/models/workflow/workflow-instance.interface';
import { AlertService } from 'app/services/alert.service';
import { Router } from '@angular/router';
import { ToastService } from 'app/services/toast.service';
import { CaseService } from 'app/services/cases.service';
import { Form } from 'app/models/form';
import { GetStepPrevInstanceDialog } from 'app/pages/cases/cases-list/cases-list.component';
import { CaseOpenFromAlert } from 'app/models/cases/cases-list.model';
import { filter, switchMap } from 'rxjs/operators';
import { FollowUpTaskToAssociate } from 'app/models/follow-up-actions/follow-up-actions.model';
import { ConsultantsPanelComponent } from '../../consultants-panel/consultants-panel.component';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workflow-current-step',
  templateUrl: 'workflow-current-step.component.html',
  styleUrls: ['workflow-current-step.component.scss'],
})

export class WorkflowCurrentStepComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(AppFormComponent) formComponent: AppFormComponent;
  @ViewChild(ConsultantsPanelComponent) consultantPanelComponent: ConsultantsPanelComponent;
    @Input()
  workflowInstanceId: number;
  @Input()
  entityId: number = 0;
  @Output()
  reviewDtoEmitter: EventEmitter<WorkflowReviewDto> = new EventEmitter();
  @Input()
  readonly: boolean;
  @Input()
  reOpenCaseMode: boolean;
  @Input()
  viewMode: boolean;

  @Output()
  loadingPage: EventEmitter<boolean> = new EventEmitter();

  @Output()
  saveProgress: EventEmitter<boolean> = new EventEmitter();

  @Output()
  changingActionToDo: EventEmitter<string> = new EventEmitter();

  currentStep: WorkflowStepInstance;
  currentStepObs$: Observable<WorkflowStepInstance>;
  workflowStepInstanceToSave: WorkflowStepInstanceToSave;

  actionToDo: UntypedFormControl;
  reason: UntypedFormControl;
  associatedAlertId: number = null;

  maxlength = 1024;
  reOpenedForm: Form;
  reOpenedSections: WorkflowStepInstanceSection[];

  @Input() onContinueObservable: Observable<void>;
  private onContinueSuscription: Subscription;

  caseSummary: string = "";
  caseTitle: string = "";
  followUpTasks: FollowUpTaskToAssociate[];

  reviewLoading: boolean = false;

  constructor(
    private workflowService: WorkflowService,
    private alertService: AlertService,
    private router: Router,
    private toast: ToastService,
    private translate: TranslateService,
    private caseService: CaseService,
    public dialog: MatDialog,
    private fuseProgressBar: FuseProgressBarService,
    ) {
  }

  ngOnInit() {
    this.actionToDo = new UntypedFormControl();
    this.reason = new UntypedFormControl('');
  }

  ngAfterViewInit() {
    this.getWorkFlowCurrentInstance();

    this.onContinueSuscription = this.onContinueObservable.subscribe(() => {
      this.getWorkFlowCurrentInstance();
      // this.verifyExistPrevAnwers();
      if (this.reviewLoading) this.reviewLoading = false;
    });
    // this.verifyExistPrevAnwers();

    this.actionToDo.valueChanges.subscribe(changes => this.changingActionToDo.emit(changes));
  }

  ngOnDestroy(): void {
    this.onContinueSuscription?.unsubscribe();
  }

  verifyExistPrevAnwers(){
    this.currentStepObs$.subscribe(value => {
      this.currentStep = value;

      if(value.workflowStepPrevInstanceIdForSameStepId){
        this.getStepPrevInstance(value);
      }
    })
  }

  getWorkFlowCurrentInstance(): void {
    // if(this.reOpenCaseMode && this.reOpenCase){
    //     this.currentStepObs$ = of(this.reOpenCase);
    //     // this.currentStep = this.reOpenCase;
    //     this.reOpenedForm = this.reOpenCase.form;
    // }else{
      // this.loadingPage.emit(true);
      this.fuseProgressBar.show();
      this.currentStepObs$ = this.workflowService.getWorkFlowCurrentInstance(this.workflowInstanceId);
      
      this.workflowService.getWorkFlowCurrentInstance(this.workflowInstanceId).subscribe(//
        res => {
          this.reOpenCaseMode = false;
          this.currentStep = res;

          if(!res.canRespond && !res.canReview && !res.canView){
            this.viewMode = true;
            this.readonly = true;
          }
          // this.currentStepObs$ = of(res);
          if(res.workflowStepPrevInstanceIdForSameStepId){
            this.getStepPrevInstance(res);
          }
          setTimeout(() => {
            const itemToScrollTo = document.getElementById('reviewAnchor');
            if(itemToScrollTo){
              itemToScrollTo.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
            this.fuseProgressBar.hide();
          }, 1000);
          // this.loadingPage.emit(false);
        },
        err => {
          // this.loadingPage.emit(false);
          this.fuseProgressBar.hide();
        }
      )
    // }
  }

  getStepPrevInstance(value: WorkflowStepInstance): void {
    // this.loadingPage.emit(true);
    this.fuseProgressBar.show();
    const dialog = this.dialog.open(GetStepPrevInstanceDialog, {
      width: '500px'
    });
    dialog.afterClosed()
    .pipe(
      filter(data => !!data)
    )
    .subscribe(
      data => {
        if(data){
          // this.loadingPage.emit(true);
          let currentStepId;
          this.fuseProgressBar.show();
          let completedResponse: WorkflowStepInstance;
          this.currentStepObs$ = this.workflowService.getWorkflowStepInstance(value.workflowStepPrevInstanceIdForSameStepId)
          .pipe(
            switchMap(res => {
              this.reOpenCaseMode = true;
              this.reOpenedForm = res.form;
              this.reOpenedSections = res.sections;
              // this.loadingPage.emit(false);
              this.fuseProgressBar.hide();
              return this.workflowService.getWorkFlowCurrentInstance(this.workflowInstanceId)
            }),
            switchMap(response => {
              currentStepId = response.id;
              if(this.reOpenedSections.length > 0){
                response.sections = this.reOpenedSections;
                response.sections.map(x => x.id = 0);
                completedResponse = response;
                return this.workflowService.getSectionsByPrevInstanceId(value.workflowStepPrevInstanceIdForSameStepId)
              }
              // this.loadingPage.emit(false);
              this.fuseProgressBar.hide();
              // return of(response);
              completedResponse = response;
              return of(completedResponse.sections);
            }),
            switchMap(sectionsComplete => {
              completedResponse.sections = sectionsComplete;
              this.workflowService.addSectionToCurrentInstance({workflowStepCurrentInstanceId: this.workflowInstanceId, workflowStepInstanceSectionAddDto: sectionsComplete, currentStepInstanceId: currentStepId})
              .subscribe(
                res => {
                  this.workflowService.getWorkFlowCurrentInstance(this.workflowInstanceId).subscribe(data => {
                    completedResponse = data;
                    this.currentStepObs$ = of(data);
                  });
                }
              );
              return of(completedResponse);
            })
          )
        }
      });
  }

  public getCompletedStep(): WorkflowStepInstanceToSave {

    const currentStep = this.currentStep;
    return {
      id: currentStep.id,
      workflowInstanceId: currentStep.workflowInstanceId,
      workflowStepId: currentStep.workflowStepId,
      completedForm: {
        id: currentStep.completedFormId || 0,
        complaintClassificationId: 0,
        formId: currentStep.form.id,
        questions: this.formComponent?.getSerializedValues(),
        key: null,
        comments: null,
        contactEmail: null,
        token: null,
      },
      sections: this.consultantPanelComponent?.getSerializedSections()
    };
    
  }

  handleAssignedTeamData(data: StakeholdersDto) {
    this.currentStep.stakeholders = data;
  }

  selectAssociatedAlert(id: number) {
    this.associatedAlertId = id ? id : null;
  }

  setNewCaseData(data: CaseOpenFromAlert){
    this.caseSummary = data.caseSummary;
    this.caseTitle = data.caseTitle;
  }

  onChageFollowUpTask(tasks){
    this.followUpTasks = tasks;
  }

  updateSections(event): void {
    this.getWorkFlowCurrentInstance();
  }

  sectionsToSave(event): void {
    this.saveProgress.emit(true);
  }

  finalizeStepInstance() {
    const actionToDo = this.actionToDo.value;
    
    const review: WorkflowReviewDto = {
      entityId: this.entityId,
      workflowInstanceId: this.workflowInstanceId,
      actionToDo: actionToDo,
      reason: this.reason.value || '',
      relatedEntityId: this.associatedAlertId,
      stakeholders: actionToDo == 'NextStep' || actionToDo == 'JumpNextStep' ? this.currentStep.stakeholders : null,
    }

    if(this.followUpTasks?.length > 0){
      review.followUpTaskToAssociateDto = this.followUpTasks;
    }

    if (this.entityId > 0) {

      review.entityId = this.entityId;
      let errorAlertCount = 0;

      if (actionToDo == 'RequestOpenANewCase') {

        review.caseSummary = this.caseSummary;
        review.caseTitle = this.caseTitle;

        if (!review.caseSummary.charAt(1) || !review.caseTitle.charAt(1)) {
          errorAlertCount++;
        }

      }
      
      if(review.stakeholders?.reviewers?.length < 1 && review.stakeholders?.reviewerGroups?.length < 1){
        this.toast.error(this.translate.instant("errors.ReviewersRequired"));
      }else{

        if (errorAlertCount < 1) {
          this.reviewLoading = true;
          this.reviewDtoEmitter.emit(review);
          if(actionToDo !== 'Discarded'){
            setTimeout(() => {
              const itemToScrollTo = document.getElementById('currentstepanchor');
              if(itemToScrollTo){
                itemToScrollTo.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
              }
            }, 3000);
          }else{
            this.reviewLoading = false;
          }
        } else {
          this.toast.error(this.translate.instant("errors.CaseTitleAndCaseSummaryAreRequired"));
        }
        
        this.actionToDo.setValue("");
      }
    }
  }

}
